import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Proyecto } from 'src/app/domain/model/catalogo/proyecto';

/**
 * Adaptador HTTP: HttpProyectoRepository
 *
 * Servicio para comunicación HTTP con el catálogo de Proyectos.
 * Endpoint: GET /api/servicios/proyectos
 */
@Injectable({ providedIn: 'root' })
export class HttpProyectoRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/proyectos`;

  /** Lista todos los proyectos activos. */
  async listarActivos(): Promise<Proyecto[]> {
    return firstValueFrom(
      this.http.get<Proyecto[]>(this.baseUrl)
    );
  }
}
